import { render, staticRenderFns } from "./PageMassMessage.vue?vue&type=template&id=32c5643f&"
import script from "./PageMassMessage.vue?vue&type=script&lang=ts&"
export * from "./PageMassMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports